import React, { useCallback } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { FAQContent } from "../../../domain/faq/FAQContent";
import { FAQTitle } from "../../../domain/faq/FAQTitle";
import { useAppDispatch } from "../../../state/store";
import { updateFAQAction } from "../../../state/usecase/faq/action";
import { BackButton } from "../common/button/BackButton";
import { FAQInput } from "./components/FAQInput";
import { Paths } from "../../../Paths";

type FaqEditPathParams = {
    faqId: string
};

export function FAQEditPage() {

    const { faqId } = useParams<FaqEditPathParams>();
    const location = useLocation();
    const initialTitle = location.state && location.state.title;
    const initialContent = location.state && location.state.content;

    if (!faqId) {
        return <Navigate to={Paths.root} />;
    }

    const dispatch = useAppDispatch();

    const handleUpdateClicked = useCallback((title: string, content: string) => {

        dispatch(
            updateFAQAction({
                faqId,
                requestData: {
                    title: FAQTitle.fromString(title),
                    content: FAQContent.fromString(content)
                }
            })
        );
    }, [dispatch, faqId]);

    return (
        <div className={"faq_add_page"}>
            <div className={"container"}>
                <BackButton />
                <p className={"header"}>FAQの更新</p>
                <FAQInput
                    initialTitle={initialTitle}
                    initialContent={initialContent}
                    handleButtonClicked={function (title: string, content: string): void {
                        handleUpdateClicked(title, content);
                    }}
                    buttonLabel={"更新"}
                />
            </div>
        </div>
    );
}
